module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-bread mt-bg-lv3"
  }, _vm._l((_vm.data), function(item) {
    return _c('span', {
      key: item.id,
      class: [_vm.activeId === item.id ? 'active mt-color-theme mt-bColor-theme' : 'mt-color-grey-lv2 mt-bColor-after-triangle-right'],
      on: {
        "click": function($event) {
          _vm.handleClick(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name) + " ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dedaa26","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/tree-selector/src/bread.vue
// module id = 422
// module chunks = 0